import { render, staticRenderFns } from "./HistoryTableRow.vue?vue&type=template&id=768aab07"
import script from "./HistoryTableRow.vue?vue&type=script&lang=ts"
export * from "./HistoryTableRow.vue?vue&type=script&lang=ts"
import style0 from "./HistoryTableRow.vue?vue&type=style&index=0&id=768aab07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports